import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BaseAnalyticsBanner from '@/components/v2/BaseAnalyticsBanner.vue';
import BaseAnalyticsBannerContent from '@/components/v2/BaseAnalyticsBannerContent.vue';
import LinkButton from '@/components/link_button/Index.vue';
import RouterParamsAppMixin from '../../../helpers/vue_mixins/RouterParamsAppMixin';
let LatestActivity = class LatestActivity extends mixins(RouterParamsAppMixin) {
    constructor() {
        super(...arguments);
        this.label = 'Latest Activity';
        this.count = 0;
    }
    get headers() {
        const defaultHeaderConfig = {
            align: 'left',
            sortable: false,
        };
        return [
            { text: 'NAME', value: 'name', ...defaultHeaderConfig },
            { text: 'TASK', value: 'task', ...defaultHeaderConfig },
            { text: 'POINTS', value: 'points', ...defaultHeaderConfig },
        ];
    }
};
LatestActivity = __decorate([
    Component({
        // TODO: add $apollo SmartQuery
        components: {
            BaseAnalyticsBanner,
            BaseAnalyticsBannerContent,
            LinkButton,
        },
    })
], LatestActivity);
export default LatestActivity;
